export default "__VITE_ASSET__B9oC$AOV__"